module.exports = __webpack_public_path__ + "static/fonts/Roboto-LightItalic.13efe6c.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/roboto-fontface/fonts/roboto/Roboto-LightItalic.woff
// module id = Xa1x
// module chunks = 3